import {
  Link,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: '100%',
    height: 72,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: -8,
  },
  link: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  linkOpen: {
    paddingLeft: 16,
    paddingRight: 12,
  },
  linkClosed: {
    justifyContent: 'center',
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link
        to="/"
        underline="none"
        className={`${classes.link} ${isOpen ? classes.linkOpen : classes.linkClosed}`}
        aria-label="Home"
      >
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
